import Comments from './Comments'

function App() {
// console.log(data)
  return (
      <Comments userName='amyrobson'/>
  );
}

export default App;
